export default "__VITE_ASSET__5e3ed0dd__"